module.exports = __webpack_public_path__ + "img/115004.5a22ac87.png";